export default {
  get: () => window && window.siteObj && window.siteObj.defaultLocale,
};
